// React-Pilot des Strangler-Programms: CAboutMode ("POSysseus Info").
// Ersetzt frontend/src/screens/aboutmode.js (ESM-Huelle von
// lib/scripts/pos/components/CMP_CAboutMode.js). Legacy-DOM-Fixture:
// tests/visual-baseline/10-overlay-posysseus-info.html (Element .CAboutMode);
// Runbook: tools/REACT-STRANGLER.md.
//
// Das Legacy-Overlay entstand aus LYT_bonOverlay.xml (9 Kinder) + einem per
// addChild erzeugten CImage. Die JSX unten ist dieses DOM 1:1 - inklusive der
// Builder-Eigenheiten (Caption-Wert steht auch im class-Attribut, ein
// fehlender Wert ergibt "CCaption undefined", ein Leerzeichen-Wert
// "CCaption  ").
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// CAboutMode.makeContentText - unveraendert (inkl. der toten Zeilen als
// Kommentar, damit der Text auf der Kasse byte-gleich bleibt).
function makeContentText() {
  const address = "<br><br>Blumen B&B<br><br>";
  const telephone = "0699 12255130";
  const telephone2 = "0664 1624290";

  let text = "<div style='margin:50px'></div>" + address;
  text += "<div style=''></div>" + telephone;
  text += "<div style=''></div>" + telephone2;
  text += "<div style='margin:30px'></div>POSweb " + POS.ProgramVersion;
  return text;
}

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return (
    <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
       dangerouslySetInnerHTML={{ __html: value }} />
  );
}

function AboutScreen({ bridge }) {
  const t = bridge.t;
  const title = t('LABELS', 'ABOUT_MODE');
  const content = makeContentText();

  // Legacy: okButton bleibt verdrahtet wie jeder CPushButton (Listener fuer
  // mousedown/mouseout/mouseup ohne Handler -> nur Dispatcher-Unlock), ist
  // aber visibility:hidden.
  const okButton = bridge.widget(7, 'CPushButton', {
    events: { onMousedown: true, onMouseout: true, onMouseup: true },
    proto: CPushButton.prototype,
  });
  // Legacy: backButton.properties.events.onMousedown = this.finish;
  //         backButton.properties.attributes.onMousedown_parameter_0 = this.id;
  //         finish: POS.getComponentById(parameters[0]).removeMe()
  const backButton = bridge.widget(8, 'CPushButton', {
    events: { onMousedown: () => bridge.removeMe(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      <div {...bridge.el(0, 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute', visibility: 'visible' }}></div>
      <div {...bridge.el(1, 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      <div {...bridge.el(2, 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      <Caption bridge={bridge} path="3" addclass="titletext" value={title} />
      <Caption bridge={bridge} path="4" addclass="contenttext" value={content} />
      <Caption bridge={bridge} path="5" addclass="pricetext" value=" " />
      <Caption bridge={bridge} path="6" addclass="unitstext" value=" " />
      <div {...okButton} className="CPushButton okbutton" style={{ visibility: 'hidden' }}>
        <p {...bridge.el('7:0', 'CCaption')} className="CCaption  " dangerouslySetInnerHTML={{ __html: ' ' }} />
      </div>
      <div {...backButton} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
      {/* Zeigte bis 26.8.2026 das POSysseus-Logo, jetzt das Logo des
          Geschaefts. Das Element bleibt als Kind 9 bestehen - eine Luecke in
          der Kinderliste laesst removeMe() abstuerzen. */}
      <img src="lib/img/customerlogo.gif" {...bridge.el(9, 'CImage')} className="CImage" style={{ position: 'absolute' }} />
    </>
  );
}

export const CAboutMode = defineReactScreen({
  className: 'CAboutMode',
  addclass: 'CAboutMode CashWindow',
  htmlType: 'div',
  Screen: AboutScreen,
  // Legacy-prepare() ohne den XML-Teil:
  prepare(bridge) {
    bridge.Main = POS.sessions.getSessionComponent();
  },
});
